import { CSSProperties, FC, ReactNode, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { PageContainer, TopNavigation } from '@medtronic/pecc-react-component-library-js';
import { Box, useMediaQuery } from '@mui/material';
import { AuthChecker } from '~/pages';
import { useAppSelector } from '~/redux';
import { selectCurrentUser } from '~/redux/slices/currentUserSlice';
import { FeedbackButtonsBlock, LeftNavigationBar, RootModal, RootNotification, TopBanner } from '.';
import { layoutStyles, pageContainerInlineStyles, pageContainerStyles, pageContainerWrapperStyles } from './styles';

interface LayoutProps {
  children?: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  const user = useAppSelector(selectCurrentUser);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const isMobile = useMediaQuery('(max-width:700px)');
  const content = children ?? <Outlet />;

  return (
    <Box sx={pageContainerWrapperStyles}>
      <TopBanner />
      <AuthChecker>
        <TopNavigation
          handleDrawerToggle={() => {
            setIsDrawerOpen((prev) => !prev);
          }}
          appName={isMobile ? '' : 'Healthcare Data Platform'}
          firstName={user?.first_name || ''}
          lastName={user?.last_name || ''}
          isWithNotification={false}
        />
        <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
          <LeftNavigationBar isDrawerOpen={isDrawerOpen} />
          <PageContainer
            // NOTE: inline style is required to override PageContainer's own height/ml/maxWidth (they win over sx)
            style={pageContainerInlineStyles as CSSProperties}
            sx={pageContainerStyles}
            customFooterProps={{
              link: 'https://medtronic.sharepoint.com/sites/OSHPI/SitePages/Healthcare-Data-Platform.aspx?csf=1&web=1&e=beQo0S&CID=499e083a-45f3-4a7c-ac73-194672d25e07',
            }}
          >
            <Box sx={layoutStyles}>
              {content}
              <FeedbackButtonsBlock />
            </Box>
            <RootNotification />
            <RootModal />
            {/* <RegionSelector /> */}
          </PageContainer>
        </Box>
      </AuthChecker>
    </Box>
  );
};

export default Layout;
